import cn from 'classnames';
import { useState } from 'react';

import s from './CardField.module.scss';

type Props = {
  label: string;
  children: React.ReactNode;
  /** Редактор значения; без него поле только для чтения */
  editor?: (close: () => void) => React.ReactNode;
  disabled?: boolean;
};

/**
 * Строка поля в карточке, как в Яндекс Трекере: подпись слева, значение справа.
 * Редактируемая строка подсвечивается при наведении, клик по ней открывает редактор на месте значения
 */
const CardField: React.FC<Props> = ({ label, children, editor, disabled = false }) => {
  const [isEditing, setIsEditing] = useState(false);
  const isEditable = !!editor && !disabled;
  const close = () => setIsEditing(false);

  const open = (event: React.SyntheticEvent) => {
    if (!isEditable || isEditing || (event.target as HTMLElement).closest('a')) return;

    setIsEditing(true);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    // Esc отменяет правку, а не закрывает всю карточку
    if (isEditing && event.key === 'Escape') {
      event.stopPropagation();
      close();

      return;
    }

    if (!isEditing && event.target === event.currentTarget && ['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      open(event);
    }
  };

  const isButton = isEditable && !isEditing;

  return (
    <div
      className={cn(s.field, isEditable && s.field_editable, isEditing && s.field_editing)}
      role={isButton ? 'button' : undefined}
      tabIndex={isButton ? 0 : undefined}
      onClick={open}
      onKeyDown={handleKeyDown}
    >
      <div className={s.field__label}>{label}</div>
      <div className={s.field__value}>{isEditing && editor ? editor(close) : children}</div>
    </div>
  );
};

export { CardField };
